import React from 'react'
import type { Maybe } from '@adc/sdk/types'
import {
  CountdownBefore,
  getServerTimeMoment,
  getStartTimeMoment,
} from 'common/modules/auctionCountdown'
import Header from 'common/modules/bidBanner/header'
import FAQSection from 'common/modules/bidBanner/faqSection'
import {
  Container,
  LeftMarginSection,
} from 'common/modules/bidBanner/container'
import _cx from 'classnames/bind'
import BidForm from 'common/modules/bidBanner/bidForm'
import ProxyBidFormUI from 'common/modules/bidBanner/bidForm/ui/proxy'
import * as BidDetails from 'common/modules/bidBanner/bidDetails'
import { useListingContext } from '../../../context/listing'
import interpolate from '../../../utils/interpolate'
import TimeInformation from '../timeInformation'
import { formatMoneyWithCentsExceptZero } from '../../../utils/formatters'
import cls from './styles.scss'
import { BID_BANNER_STATES, getBidBannerState } from './common'
import { BidBannerProps } from './../'
const cx = _cx.bind(cls)

const HEADERS = {
  USER_WITH_MAX_BID: 'Your Max Bid was submitted.',
  USER_WITH_MAX_BID_SUBTEXT: `You may set a new Max Bid higher than %s.`,
  USER_WITHOUT_MAX_BID: 'Set your Max Bid before the auction.',
  USER_WITHOUT_MAX_BID_SUBTEXT: `Enter your highest and best offer before it starts.`,
}
interface BeforeProps extends BidBannerProps {
  bidDeposit: Maybe<number | undefined>
}

export const Before = (props: BeforeProps) => {
  const { segment, listing } = useListingContext()

  const renderBidDetails = () => {
    const { bidDeposit } = props
    return (
      <LeftMarginSection>
        <BidDetails.Before bidDeposit={bidDeposit} />
      </LeftMarginSection>
    )
  }

  const renderTopBeforeAuction = () => {
    return (
      <div className={cx('u-mb-5')}>
        <TimeInformation segment={segment} />
      </div>
    )
  }

  const renderRight = () => {
    if (!segment) {
      return null
    }

    const { featureFlags, user } = props

    return (
      <>
        <div className={cx('u-mb-6')}>
          <CountdownBefore
            endTime={getStartTimeMoment(segment)}
            currentServerTime={getServerTimeMoment(segment)}
          />
        </div>

        <BidForm
          featureFlags={featureFlags}
          segment={segment}
          listing={listing}
          user={user}
        >
          {(props: any) => <ProxyBidFormUI {...props} segment={segment} />}
        </BidForm>
      </>
    )
  }

  const renderUserWithProxyBid = () => {
    const headerSubText = interpolate(HEADERS.USER_WITH_MAX_BID_SUBTEXT, [
      formatMoneyWithCentsExceptZero(
        segment?.current_user_max_bid?.max_bid_amount
      ),
    ])
    return (
      <Container
        ribbonColor='success'
        left={
          <>
            {renderTopBeforeAuction()}
            <div className={cx('u-mb-3')}>
              <Header
                color='success'
                icon={<Header.IconSmile />}
                subText={headerSubText}
                text={HEADERS.USER_WITH_MAX_BID}
              />
            </div>
            {renderBidDetails()}
            <FAQSection />
          </>
        }
        right={renderRight()}
      />
    )
  }

  const renderUserWithoutProxyBid = () => {
    const headerSubText = segment?.starting_bid_amount
      ? interpolate(HEADERS.USER_WITHOUT_MAX_BID_SUBTEXT, [
          formatMoneyWithCentsExceptZero(segment.starting_bid_amount),
        ])
      : null
    return (
      <Container
        ribbonColor='adcLightBlue'
        left={
          <>
            {renderTopBeforeAuction()}
            <div className={cx('u-mb-3')}>
              <Header
                color='adcLightBlue'
                icon={<Header.IconGavel color='adcLightBlue' />}
                subText={headerSubText}
                text={HEADERS.USER_WITHOUT_MAX_BID}
              />
            </div>
            {renderBidDetails()}
            <FAQSection />
          </>
        }
        right={renderRight()}
      />
    )
  }

  switch (getBidBannerState(segment, listing)) {
    case BID_BANNER_STATES.USER_WITH_PROXY_BID:
      return renderUserWithProxyBid()
    case BID_BANNER_STATES.USER_WITHOUT_PROXY_BID:
      return renderUserWithoutProxyBid()
    default:
      return null
  }
}
